import api from '../../axios_api'
import _ from 'lodash'
import Promise from 'bluebird'
import router from '../../main'


const state = {
    diligenceStage: []
}

const getters = {
    diligenceStageData: (state) => state.diligenceStage,
    diligenceStageCount: (state) => state.diligenceStage.length
}
const mutations = {
    initialize(state) {
        state.diligenceStage = []
    },
    merge(state, payload) {
        // merge our local with what has returned
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        // state.diligenceStagetage = payload;
        state.diligenceStage = _.map(state.diligenceStage, addr => {
            let index = _.findIndex(payload, function (a) { return a._id === addr._id })
            if (index >= 0) {
                return _.first(_.pullAt(payload, index))
            }
            return addr
        })
        if (!_.isEmpty(payload)) state.diligenceStage = _.concat(state.diligenceStage, payload)
        state.diligenceStage = _.without(state.diligenceStage, null, undefined)
    },
    remove(state, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return
        // remove the item by the id (either _id or uaid)
        state.diligenceStage = _.filter(state.diligenceStage, function (a) { return a._id !== payload && a.uaid !== payload })
    }
}

const actions = {
    start({ state, dispatch, commit }) {
        commit('initialize')
        dispatch('apiFetchDiligenceStage')
            .then(() => {
            })
            .catch(() => { })
    },
    merge(state, payload) {
        // merge our local with what has returned
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        state.diligenceStage = payload
    },
    stop({ commit }) {
        // clean up
        commit('initialize')
    },
    apiFetchDiligenceStage({ commit, dispatch }) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
                let url = `/${fiifi.workspace_id}/diligence_stage`;
                return api.get(url)
                    .then(res => {
                        commit('merge', res.data.encrypt.success)
                        return Promise.resolve(res.data.encrypt.success)
                    })
                    .catch(err => {
                        return Promise.reject(err)
                    })
            }
        }
    },
    apiPostDiligenceStageInst({ rootGetters, dispatch }, payload) {
        // payload should be a company instance
        let currentRole = rootGetters['role/current_role'];
        let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/diligence_stage`;
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                // res should be the updated company info
                dispatch('apiFetchDiligenceStage')
                    .then(() => {
                    })
                    .catch(() => { })
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiPatchDiligenceStageInst({ }, payload) {
        // payload should be a Company instance
        let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/diligence_stage`;

        return api.patch(url, { encrypt: { data: payload } })
            .then(res => {
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiPostStageInst({ dispatch }, payload) {
        // payload should be a Company instance
        let url = `/new/diligence_stage/${router.currentRoute.params.workspace_id}`;

        return api.post(url, { encrypt: { data: payload } })
            .then(res => {
                dispatch('apiFetchDiligenceStage')
                    .then(() => {
                    })
                    .catch(() => { })
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiDeleteStage({ dispatch, commit }, payload) {
        let url = `${payload.workspace_id}/${payload._id}/stage`;
        return api.delete(url, { encrypt: { data: payload } })
            .then(res => {
                commit('remove', payload._id)
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}